import {
  getInt32,
} from "@surya-digital/leo-ts-types";

export interface ProjectItemsPerPageDTO {
  items: number;
}

export class ProjectItemsPerPage {
  readonly isProjectItemsPerPageProjectItemsPerPage: boolean = true;

  readonly items: number;

  static readonly constraints = {
    "items": {
      "minValue": 1,
    }
  }

  constructor(
  items: number
  ) {
    ProjectItemsPerPage.validateItems(items);
    this.items = items;
  }

  static fromDTO(dto: ProjectItemsPerPageDTO): ProjectItemsPerPage {
    const items = getInt32(dto, "items", InvalidProjectItemsPerPageItemsError);
    return new ProjectItemsPerPage(
      items
    );
  }

  toDTO(): ProjectItemsPerPageDTO {
    const dto: ProjectItemsPerPageDTO = {
        items: this.items
    };
    return dto;
  }
  private static validateItems = (items: number): void => {
    if(items < 1) {
      throw new InvalidProjectItemsPerPageItemsMinValueError(
        1,
        `Attribute items has value ${items}. Min value is 1.`
      );
    }
  }
  
}

ProjectItemsPerPage.prototype.toString = function toString(): string {
  return `ProjectItemsPerPage(items='${this.items}')`;
};

export class InvalidProjectItemsPerPageError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidProjectItemsPerPageError";
  }
}
export class InvalidProjectItemsPerPageItemsError extends InvalidProjectItemsPerPageError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidProjectItemsPerPageItemsError";
  }
}

export class InvalidProjectItemsPerPageItemsMinValueError extends InvalidProjectItemsPerPageItemsError {
  readonly minValue: number;
  constructor(minValue: number, message?: string) {
    super(message);
    this.minValue = minValue;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidProjectItemsPerPageItemsMinValueError";
  }
}
